import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const SidebarItemSeason = ({ t, onClickButton, isButtonLarge }) => {
  return (
    <Button
      type={'text'}
      className={styles.sidebarItemButtonSeason}
      icon={<CroplerIcon name="add" />}
      onClick={onClickButton}
      title={t('nav.seasonAdd')}
      size={isButtonLarge ? 'large' : ''}
    />
  );
};

export default SidebarItemSeason;
